import { Navigate } from 'react-router-dom'
import PageTransition from '@/components/ui/PageTransition'
import Section from '@/components/layout/Section'
import ProjectNav from '@/components/ui/ProjectNav'
import TobiHero from '@/components/tobi/TobiHero'
import TobiScrollytelling from '@/components/tobi/TobiScrollytelling'
import TobiHomepage from '@/components/tobi/TobiHomepage'
import TobiImpact from '@/components/tobi/TobiImpact'
import { getProjectBySlug, getAdjacentProjects } from '@/data/projects'

export default function TobiPage() {
  const project = getProjectBySlug('tobi')

  if (!project) {
    return <Navigate to="/" replace />
  }

  const { prev, next } = getAdjacentProjects('tobi')

  return (
    <PageTransition>
      <Section className="pt-8 md:pt-12">
        <TobiHero project={project} />
      </Section>

      <Section className="py-12 md:py-16">
        <TobiScrollytelling />
      </Section>

      <Section className="pb-12 md:pb-16">
        <TobiHomepage />
      </Section>

      <Section className="pb-12 md:pb-16">
        <TobiImpact />
      </Section>

      <Section>
        <ProjectNav prevProject={prev} nextProject={next} />
      </Section>
    </PageTransition>
  )
}
